<template>
    <div class="LotteryDraw">
        <headSssembly v-if="isAppOpen" titleTransparent="幸运折扣" :showShare="true" @share="share"/>
        <div v-show="!isAppOpen" class="goApp">
            <img id="download" src="../../../assets/img/activity/lotteryDraw/goApp.png" alt="">
        </div>
        <div class="top">
            <img class="mainTopText" src="../../../assets/img/activity/lotteryDraw/mainTopText.png" alt="">
            <img class="mainText" src="../../../assets/img/activity/lotteryDraw/mainText.png" alt="">
            <div class="scroller" v-if="raffleInfo">
                <van-notice-bar :scrollable="false">
                    <van-swipe
                        vertical
                        class="notice-swipe"
                        :autoplay="3000"
                        :show-indicators="false"
                    >
                        <van-swipe-item v-for="(item, index) in raffleInfo.list" :key="index">
                            <p><em>{{ item.name.length > 6 ? item.name.slice(0, 6) + '...' : item.name }}</em>抽中了<span>{{item.desc}}</span></p>
                        </van-swipe-item>
                    </van-swipe>
                </van-notice-bar>
            </div>
        </div>
        <div class="main">
            <img class="people" :src="imgArr[this.currentIndex] || '../../../assets/img/activity/lotteryDraw/shoot_00001.png'" alt="">
            <div class="btn" @click="draw">
                <p>剩余抽奖机会：{{raffleInfo ? raffleInfo.count : 1}}次</p>
            </div>
            <img @click="gotoRecord" class="record" src="../../../assets/img/activity/lotteryDraw/mainRecord.png" alt="">
        </div>
        <div class="ruleBox">
            <div class="rule">
                <img src="../../../assets/img/activity/lotteryDraw/mainRuleText.png" alt="">
                <div class="txt">
                    <p>1.用户每天可以获取一次抽奖机会</p>
                    <p>2.抽奖奖品为站内的嗨币红包，可用于方案，模型等付费产品的解锁</p>
                    <p>3.本业务为试运营，规则可能会不定时调整，最终解释权归平台所有</p>
                    <p>4.iOS用户抽到模型红包后，请到“我的”中联系客服使用～</p>
                </div>
            </div>
        </div>
        <van-overlay :show="showPop" @click="show = false" />
        <div v-if="showPop" class="model" :class="{'showModel': isStartPopAnimate || !isAnimation, 'isAnimation': isAnimation}">
            <div class="modelBox">
                <img class="bg" src="../../../assets/img/activity/lotteryDraw/pop_49.png" alt="">
                <div v-if="raffleShoot && raffleShoot.prize_type != 0" class="box" :class="{'showBox': showPopCon}">
                    <p class="tit">成功获得{{raffleShoot.coupon_info ? raffleShoot.coupon_info.length : 0}}个红包：</p>
                    <div class="prizeBox">
                        <div class="prize">
                            <div class="item" v-for="(item, index) in raffleShoot.coupon_info" :key="index">
                                <div class="tips">{{ raffleShoot.prize_type == 1 ? '即嗨号红包' : item.name }}</div>
                                <div class="price">{{ item.amount / 100 }}<span>嗨币</span></div>
                                <div class="describe">{{ item.min_amount > 0 ? `满${ item.min_amount / 100 }可用` : '红包立减'}}</div>
                            </div>
                        </div>
                    </div>
                    <div class="btm">
                        <span @click="closeModel">先收下</span>
                        <span class="ok" @click="goToEmploy">去使用</span>
                    </div>
                </div>
                <div v-else class="box" :class="{'showBox': showPop}">
                    <p class="tit">很遗憾，未获得奖励</p>
                    <div class="prizeBox">
                        <div class="prize noPrize">
                            <img src="../../../assets/img/activity/lotteryDraw/noPrize.png" alt="">
                        </div>
                    </div>
                    <div class="btm">
                        <span  @click="closeModel" class="ok noBtn">下次再来</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import headSssembly from "@/components/common/headSssembly"
import jsbridg from '@/utils/jsbridg.js'
import { isJHApp, isLogin, doLogin } from '@/utils/base.js'
import { importSdk } from "@/utils/tools";
import { getActivityRaffleInfo, getActivityRaffleShoot } from "../../../api/activity";
import { Toast } from "vant";
export default {
    name: 'LotteryDraw',
    components: {
        headSssembly
    },
    data () {
        return {
            isAppOpen: isJHApp(),
            animationState: false,
            imgArr: [],
            currentIndex: 0,
            timer: null,
            showPop: false,
            isStartPopAnimate: false,
            showPopCon: false,
            raffleInfo: null,
            raffleShoot: null,
            isAnimation: true,
            OpenInstall: null
        };
    },
    created () {
        if (!isJHApp()) {
            importSdk("https://web.cdn.openinstall.io/openinstall.js", this.initOpenInstall);
        } else {
            jsbridg.hideAppBar(0)
        }
        document.getElementsByTagName('title')[0].innerHTML = '幸运折扣';
        this.preload();
        this.getActivityRaffleInfo()
    },
    destroyed () {
        clearInterval(this.timer);
        if (this._raf) {
            cancelAnimationFrame(this._raf);
            this._raf = null;
        }
    },
    mounted () {
        // 监听页面显示隐藏
        document.addEventListener('visibilitychange', () => {
            if (document.visibilityState === 'visible') {
                this.getActivityRaffleInfo();
            }
        });
    },
    methods: {
        async getActivityRaffleInfo () {
            const res = await getActivityRaffleInfo()
            if (res.errno === 0) {
                this.raffleInfo = res.data;
            }
        },
        async getActivityRaffleShoot () {
            const res = await getActivityRaffleShoot()
            if (res.errno === 0) {
                this.raffleShoot = res.data
            } else if (res.errno === -1) {
                doLogin();
            } else {
                this.isAnimation = false;
            }
        },
        goToEmploy () {
            if (this.isAppOpen) {
                if (Number(this.raffleShoot.prize_type) === 1) {
                    jsbridg.goWebview({
                        code: 501,
                        jumptype: 1,
                        params: "newsPlateType=16"
                    });
                } else {
                    jsbridg.goWebview({
                        code: 15,
                        jumptype: 1
                    });
                }
            } else {
                this.OpenInstall.wakeupOrInstall()
            }
        },
        share () {
            var shareobj = {
                title: '幸运折扣',
                desc: "抽即嗨方案全场1折福利",
                link: window.location.href,
                imgUrl: 'https://img0.jihai8.com/default/jihai_logo.png'
            }
            jsbridg.appShare(shareobj);
        },
        initOpenInstall () {
            /* eslint-disable*/
            var data = OpenInstall.parseUrlParams();///openinstall.js中提供的工具函数，解析url中的所有查询参数
            this.OpenInstall = new OpenInstall({
                /*appKey必选参数，OpenInstall平台为每个应用分配的ID*/
                appKey : process.env.VUE_APP_OPENINSTALLAPPKEY,
                onready : function() {
                    /*在app已安装的情况尝试拉起app*/
                    this.schemeWakeup();
                    /*用户点击某个按钮时(假定按钮id为downloadButton)，安装app*/
                    var m = this;
                    var btn_1 = document.getElementById('download');
                    btn_1.style.visibility = "visible";
                    btn_1.onclick = function() {
                        m.wakeupOrInstall();
                        return false;
                    }
                }
            }, data);
        },
        closeModel () {
            this.showPop = false;
            this.isStartPopAnimate = false;
            this.showPopCon = false;
            // 重置抽奖状态
            this.currentIndex = 0;
            clearInterval(this.timer);
            if (this._raf) {
                cancelAnimationFrame(this._raf);
                this._raf = null;
            }
        },
        preload () {
            // 预加载资源并记录加载状态，避免安卓 WebView 切帧时空白/丢帧
            this._imgCache = [];
            for (let i = 0; i <= 40; i++) {
                const path = i < 10
                    ? require(`../../../assets/img/activity/lotteryDraw/shoot_0000${i}.png`)
                    : require(`../../../assets/img/activity/lotteryDraw/shoot_000${i}.png`);
                this.imgArr.push(path);
                const img = new Image();
                img.src = path;
                img.onload = () => { this.$set(this._imgCache, i, true); };
                img.onerror = () => { this.$set(this._imgCache, i, false); };
            }
        },
        gotoRecord () {
            if (!isLogin()) {
                doLogin();
                return;
            }
            // if (isJHApp()) {
            //     jsbridg.goWebview({
            //         jumptype: 2,
            //         url: process.env.VUE_APP_DOMAIN + '/activity/lotteryDraw/record',
            //     });
            // } else {
                this.$router.push({ path: '/activity/lotteryDraw/record' });
            // }
        },
        async draw () {
            if (!isLogin()) {
                 doLogin();
                 return;
            }
            window.scrollTo({
                top: 0,
                behavior: 'smooth' // 平滑滚动效果
            });
            if (Number(this.raffleInfo ? this.raffleInfo.count : 0) > 0) {
                Toast.loading({
                    duration: 0, // 持续展示 toast
                    forbidClick: true,
                });
                await this.getActivityRaffleShoot()
                Toast.clear();
                if (!this.raffleShoot) {
                    // this.$toast('抽奖失败，请稍后再试');
                    return;
                }
                if (Number(this.raffleInfo.price_type) === 0) {
                    this.isAnimation = false;
                } else {
                    this.isAnimation = true;
                }
                this.raffleInfo.count --
                this.currentIndex = 0
                clearInterval(this.timer);
                // 使用 requestAnimationFrame 驱动帧切换，按时间步进，兼容安卓 WebView
                clearInterval(this.timer);
                if (this._raf) {
                    cancelAnimationFrame(this._raf);
                    this._raf = null;
                }
                const frameDuration = 37; // ms per frame
                let lastTs = 0;
                const step = (ts) => {
                    if (!lastTs) lastTs = ts;
                    if (ts - lastTs >= frameDuration) {
                        lastTs = ts;
                        const nextIndex = this.currentIndex + 1;
                        if (nextIndex >= this.imgArr.length) {
                            // 动画结束
                            this.currentIndex = this.imgArr.length - 1;
                            if (this._raf) {
                                cancelAnimationFrame(this._raf);
                                this._raf = null;
                            }
                            this.showPop = true;
                            this.$nextTick(() => {
                                setTimeout(() => { this.isStartPopAnimate = true; }, 100);
                                setTimeout(() => { this.showPopCon = true; }, 600);
                            });
                            return;
                        }
                        // 仅在帧图片已加载时推进，避免安卓显示空白
                        if (this._imgCache && this._imgCache[nextIndex]) {
                            this.currentIndex = nextIndex;
                        } else {
                            // 触发加载，等待下一次检查
                            const preloadImg = new Image();
                            preloadImg.src = this.imgArr[nextIndex];
                            preloadImg.onload = () => { this.$set(this._imgCache, nextIndex, true); };
                        }
                    }
                    this._raf = requestAnimationFrame(step);
                };
                this._raf = requestAnimationFrame(step);
            } else {
                this.$toast('今日抽奖次数用完，明天再来～');
            }
        }
    }
}
</script>

<style lang="less" scoped>
// 引入字体
@font-face {
    font-family: 'DIN_Alternate';
    src: url('../../../../public/font/DIN_Alternate.ttf') format('truetype');
}
.LotteryDraw{
    width: 100%;
    background-image: url("../../../assets/img/activity/lotteryDraw/mainBg.png");
    background-size: 100% 667px;
    background-repeat: no-repeat;
    background-color: #33CE85;
    min-height: 100%;
    padding-bottom: 20px;
    overflow: hidden;
    .goApp{
        padding: 0 16px;
        margin-top: 8px;
        margin-bottom: 8px;
        img{
            width: 350px;
            height: 40px;
            object-fit: fill;
            margin: 0 auto;
        }
    }
    .top{
        img{
            display: block;
            margin: 0 auto;
        }
        .mainTopText{
            width: 165px;
        }
        .mainText{
            width: 265px;
            margin-top: -5px;
        }
        .scroller{
            width: 245px;
            height: 22px;
            border-radius: 15px;
            background: rgba(4,20,49,0.6);
            overflow: hidden;
            margin: 0 auto;
            /deep/.van-notice-bar{
                background-color: transparent;
                height: 100%;
                width: 100%;
                padding: 0;
                color: #fff;
                .van-notice-bar__content{
                    width: 100%;
                }
            }
            .notice-swipe {
                width: 100%;
                height: 22px;
                line-height: 22px;
                font-size: 11px;
                background-color: transparent;
                padding: 0 10px;
                p{
                    text-align: center;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    span{
                        color: #ffff00;
                    }
                }
            }
        }
    }
    .main{
        width: 100%;
        position: relative;
        img.people{
            display: block;
            width: 320px;
            height: 563px;
            margin-top: -114px;
            margin-left: 30px;
            transition: all 37ms ease;
        }
        .btn{
            width: 192px;
            height: 80px;
            background-image: url("../../../assets/img/activity/lotteryDraw/mainBtnBg.png");
            margin: 0 auto;
            background-size: cover;
            margin-top: -100px;
            text-align: center;
            color: #fff;
            overflow: hidden;
            p{
                font-size: 12px;
                font-weight: bold;
                text-shadow: 0 1px 2px #ff145b;
                margin-top: 30px;
            }
        }
        .record{
            width: 54px;
            position: absolute;
            right: 12px;
            bottom: 15px;
        }
    }
    .ruleBox{
        padding: 0 12px;
        margin-top: 16px;
        .rule{
            padding: 12px;
            border-radius: 16px;
            background-color: #fff;
            img{
                width: 84px;
                display: block;
                margin: 0 auto;
            }
            .txt{
                margin-top: 10px;
                p{
                    font-size: 13px;
                    color: #030C1B;
                    line-height: 24px;
                    margin-top: 3px;
                }
            }
        }
    }
    .model{
        position: fixed;
        width: 28px;
        height: 32px;
        left: calc(50% - 14px);
        top: 160px;
        z-index: 1000;
        transform: rotate3d(0, 1, 0, 0deg);
        .modelBox{
            width: 100%;
            height: 100%;
            position: relative;
            .bg{
                width: 100%;
            }
            .box{
                width: 100%;
                height: 180px;
                left: 0;
                bottom: -50px;
                opacity: 0;
                transition: all 0.3s ease;
                position: absolute;
                padding-left: 45px;
                padding-right: 35px;
                transform: scale(0.2);
                .tit{
                    font-size: 15px;
                    font-weight: bold;
                    color: #FF2962;
                }
                .prizeBox{
                    width: 100%;
                    height: 84px;
                    margin-top: 16px;
                    overflow-x: auto;
                    &::-webkit-scrollbar{
                        display: none;
                    }
                    scrollbar-width: none;
                    .prize{
                        width: max-content;
                        display: flex;
                        justify-content: flex-start;
                        flex-wrap: nowrap;
                        height: 100%;
                        .item{
                            width: 64px;
                            height: 100%;
                            background-image: url("../../../assets/img/activity/lotteryDraw/prizeBg.png");
                            background-size: contain;
                            background-repeat: no-repeat;
                            margin-right: 8px;
                            &:last-child{
                                margin-right: 0;
                            }
                            display: flex;
                            flex-direction: column;
                            align-items: center;
                            .tips{
                                width: 54px;
                                height: 17px;
                                background: #FFDAE4;
                                border-radius: 0px 0px 6px 6px;
                                font-size: 9px;
                                color: #FF2962;
                                display: flex;
                                align-items: center;
                                justify-content: center;
                            }
                            .price{
                                display: flex;
                                align-items: center;
                                justify-content: center;
                                font-size: 24px;
                                color: #FF2962;
                                font-family: DIN_Alternate;
                                span{
                                    font-size: 10px;
                                    margin-top: 6px;
                                }
                            }
                            .describe{
                                font-size: 10px;
                                color: #FF2962;
                                display: flex;
                                align-items: center;
                                justify-content: center;
                            }
                        }
                    }
                    .noPrize{
                        width: 100%;
                        justify-content: center;
                        img{
                            width: 89px;
                            display: block;
                        }
                    }
                }
                .btm{
                    display: flex;
                    justify-content: space-between;
                    margin-top: 10px;
                    padding-right: 10px;
                    span{
                        display: block;
                        width: calc(50% - 5px);
                        height: 40px;
                        border-radius: 51px;
                        border: 1px solid #FF2962;
                        text-align: center;
                        line-height: 40px;
                        font-size: 14px;
                        color: #FF2962;
                    }
                    .ok{
                        background: linear-gradient(to bottom, #FFB0B6 0%, #FF0F47 100%);
                        color: #fff;
                        border: none;
                    }
                    .noBtn{
                        width: 100%;
                    }
                }
            }
            .showBox{
                opacity: 1;
                transform: scale(1);
            }
        }
        &.showModel{
            width: 310px;
            height: 324px;
            left: calc(50% - 155px);
            top: 80px;
            transform: rotate3d(0, 1, 0, 360deg);
        }
         &.isAnimation{
            transition: all 700ms ease;
        }
    }
}
</style>
